import BackgroundImage from "@components/BackgroundImageCst";
import { Container, Grid } from "@mui/material";
import CardHomeCst from "@components/CardHomeCst";
import { useTranslation } from "react-i18next";
import Breadcrumb from "@components/Breadcrumb";
import { useMenu, useNavigaionRoutes } from "@hooks/useNavigation";
import { useAuth } from "@context/auth";
import HeroCst from "@components/HeroCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useResetFilters } from "@hooks/useFiltersProvider";
import { useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { useParams } from "react-router-dom";

const DashboardCorporatePage: React.FC = () => {
  const { t } = useTranslation(["dashboard-digited-page", "common"]);
  const { user } = useAuth();
  const { id } = useParams();

  useResetFilters();

  const dashboardSection = [
    "smartconfigurator.quicksight.associate.users.roles",
    "smartconfigurator.quicksight.read",
  ];

  const { dataDetail } = useFetchDetail(
    ServicesURL.corporate,
    id || "",
    PagesID["corporate"],
  );

  const navigation = useNavigaionRoutes();

  let menuItem = [];
  menuItem = navigation
    .find((el) => el.to === "corporate")
    ?.children?.filter((el: { section: string }) => {
      return (
        user?.permissions?.includes(el.section) &&
        dashboardSection?.includes(el.section)
      );
    });

  let dashboardMenu = [];

  if (menuItem.length > 0) {
    dashboardMenu = menuItem
      .find((el: any) => el.to === "dashboard")
      ?.children?.filter((el: { section: string }) => {
        return (
          user?.permissions?.includes(el.section) &&
          dashboardSection?.includes(el.section)
        );
      });
  }

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-dashboard.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={`${dataDetail?.name} - ${t("hero-title")}`}
          description={t("hero-description")}
        />
        <Grid container spacing={3}>
          {dashboardMenu.length > 0 &&
            dashboardMenu.map(
              (
                { image, to, disabled, text, buttonLabel, description }: any,
                index: React.Key | null | undefined,
              ) => (
                <Grid key={index} item xs={12} md={6} lg={4}>
                  <CardHomeCst
                    image={image}
                    title={text}
                    description={description}
                    secondaryBtnLabel={buttonLabel}
                    to={to}
                    disabled={disabled}
                  />
                </Grid>
              ),
            )}
        </Grid>
      </Container>
    </AnimationFadeIn>
  );
};

export default DashboardCorporatePage;
